<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Terminal Agreement - {{this.model.id}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="edit_terminal_agreement">Edit</b-dropdown-item>
					<b-dropdown-item @click="delete_terminal_agreement">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
	    <b-card  v-if="loadingData">
			<b-col cols="12" sm="12" md="12" lg="12">
				<p class="text-center">
					<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
				</p>
			</b-col>
        </b-card>
		<div v-else>
			<b-card v-if="found" class="p-0">
				<b-card title="Basic Info" class="p-0 m-0 mb-3">
					<b-row>
						<b-col sm="6">
							<b-form-group :label-cols="4" vertical label="Initial Date" label-for="initial_date">
								<b-form-input v-if="!edit" v-model="model.initial_date" type="text" readonly />
								<b-form-input v-else id="initial_date" v-model="model.initial_date" type="date" :readonly="!edit"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="4" vertical label="End Date" label-for="end_date">
								<b-form-input v-if="!edit" v-model="model.end_date" type="text" readonly />
								<b-form-input v-else id="end_date" v-model="model.end_date" type="date" :readonly="!edit"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">					
							<b-form-group :label-cols="3" vertical label="Energy Company" label-for="energyCompanies">
								<b-form-select v-if="(role =='super_admin' && edit)" value-field="id" text-field="name" id="energyCompanies" v-model="model.energy_company_id" :options="energycompanies" @input="select_energy_company" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.energy_company" type="text" readonly />
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group v-if="fluidtypes.length > 0" :label-cols="3" id="L5" label="Fluid Type" label-for="fluidtypesID" vertical>
								<b-form-radio-group v-if="edit" value-field="other" text-field="name" v-model="fluid_type" class="custom-checkboxes" :options="fluidtypes" name="Checkboxes2" plain @input="select_fluid_type" :disabled="!edit"></b-form-radio-group>
								<b-form-input v-else v-model="model.fluid_type" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="model.other_terms.length > 0" >
						<b-col sm="6">		
							<b-form-group :label-cols="3" vertical label="Stream Type" label-for="streamtype">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="streamtype" v-model="model.other_terms[0].stream_type_id" :options="fluid_type.stream_type" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select stream type --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.other_terms[0].stream_type_name" type="text" readonly />
							</b-form-group>
						</b-col>
						<b-col sm="6">	
							<b-form-group :label-cols="3" vertical label="Blending Dry Fee" label-for="blending_dry_fee">
								<b-form-input v-if="edit" id="blending_dry_fee" v-model="model.other_terms[0].blending_dry_fee" type="text" @keydown.native="myOnlyNumber($event, 'rate')" :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.other_terms[0].blending_dry_fee1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">					
							<b-form-group :label-cols="3" vertical label="Terminal Company" label-for="terminalCompanies">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="terminalCompanies" v-model="model.terminal_company_id" :options="terminalcompanies" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select terminal company --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.terminal_company" type="text" readonly />
							</b-form-group>
						</b-col>
						<b-col sm="6">					
							<b-form-group :label-cols="3" vertical label="Terminal" label-for="terminal">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="terminal" v-model="model.terminal_id" :options="terminals" @input="select_terminal" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select terminal --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.terminal" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Terminal Rate" label-for="rate">
								<b-form-input v-if="edit" id="rate" v-model="model.rate" type="text" @keydown.native="myOnlyNumber($event, 'rate')" placeholder="The regular terminal fee that will apply to all hauls" :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.rate1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>	
				</b-card>
			
				<b-card title="Treatment Fees" class="p-0 m-0 mb-3">
					<p>
					Treatment fees that will apply only to those hauls which H2S condition apply as shows below 
					</p>
					<b-table striped show-empty empty-text="No Treatement fees added"
						:fields = "[{key: 'delete', label: ' '}, {key: 'treatment_fee_type_id', label: 'Type'}, {key: 'treatment_fee', label: 'Treatment fee'}, {key: 'condition_id', label: 'Condition'}, {key: 'percentage', label: 'Percentage'}]" 
						:items="model.treatfees" stacked="sm" outlined small>
						<template v-if="edit" slot="delete" slot-scope="item">
							<b-btn v-b-tooltip.hover title="Delete" v-on:click="removetreatmentfee(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
						</template>
						<template slot="treatment_fee_type_id" slot-scope="item">
							<b-form-select  v-if="edit" size="sm" id="type" v-model="model.treatfees[item.index].treatment_fee_type_id" :options="treatment_fee_type">
								<template slot="first"><option :value="null" disabled>-- select type --</option></template>
							</b-form-select>
							<span v-else>{{model.treatfees[item.index].treatment_fee_type_name}}</span>
						</template>
						<template slot="treatment_fee" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="treatmentfee" v-model="model.treatfees[item.index].treatment_fee" type="text" @keydown.native="myOnlyNumber($event, 'treatmentfee')"/>
							<span v-else>{{model.treatfees[item.index].treatment_fee1}}</span>
						</template>
						<template slot="condition_id" slot-scope="item">
							<b-form-select v-if="edit" size="sm" id="condition" v-model="model.treatfees[item.index].condition_id" :options="condition">
								<template slot="first"><option :value="null" disabled>-- select condition --</option></template>
							</b-form-select>
							<span v-else>{{model.treatfees[item.index].condition_name}}</span>
						</template>
						<template slot="percentage" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="percentage" v-model="model.treatfees[item.index].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
							<span v-else>{{model.treatfees[item.index].percentage1}}</span>
						</template>
					</b-table>
					<b-row v-if="edit">
						<b-col sm="12">
							<b-btn  v-on:click="addtreatmentfee()" size="sm" variant="primary" class="pull-right">Add New Treatment Fee</b-btn>
						</b-col>
					</b-row>
				</b-card>

				<b-card title="Other Fees" class="p-0 m-0 mb-3">
					<p>
						Any other fees added here will be automatically apply to all hauls that unload in this location that contains water as a fluid type
					</p>
					<b-table striped show-empty empty-text="No other fees have been added"
						:fields = "[{key: 'delete', label: ' '}, {key: 'terminal_rate', label: 'Terminal Rate'}, {key: 'rate', label: 'Rate'}]" 
						:items="model.otherfees" stacked="sm" outlined small>
						<template v-if="edit" slot="delete" slot-scope="item">
							<b-btn v-b-tooltip.hover title="Delete" v-on:click="removeotherfee(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
						</template>
						<template slot="terminal_rate" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="otherfee" v-model="model.otherfees[item.index].terminal_rate" type="text" />
							<span v-else>{{model.otherfees[item.index].terminal_rate}}</span>
						</template>
						<template slot="rate" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="otherrate" v-model="model.otherfees[item.index].rate" type="text" @keydown.native="myOnlyNumber($event, 'rate')"/>
							<span v-else>{{model.otherfees[item.index].rate1}}</span>
						</template>
					</b-table>
					<b-row v-if="edit">
						<b-col sm="12">
							<b-btn  v-on:click="otherfee()" size="sm" variant="primary" class="pull-right">Add Other Fee</b-btn>
						</b-col>
					</b-row>
				</b-card>

				<b-card title="Unload Locations" class="p-0 m-0 mb-3">
					<p>
					Any other fees added here will be automatically apply to all hauls that unload in this location that  contains water as a fluid type
					</p>
					<b-table striped show-empty empty-text="No Unload Locations have been added"
						:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: 'Unload Location'}, {key: 'shipping_cost', label: 'Shipping Cost'}, {key: 'monthly_commitment', label: 'Monthly Commitment'}, {key: 'contact_person', label: 'Contact Person'}, {key: 'contact_email', label: 'Contact Email'}, {key: 'show_details', label: ' '}]" 
						:items="model.unload_locations" stacked="sm" outlined small>
						<template slot="show_details" slot-scope="row">
							{{model.unload_locations[row.index].terminal_costs.length>0 && !row.detailsShowing ? row.toggleDetails() : '' }}<b-btn v-if="edit" v-b-tooltip.hover title="Add Terminal Cost" @click="addterminalcost(row)" size="sm" class="pull-right"><i class="icon-plus"></i> Cost</b-btn>
						</template>
						<template slot="row-details" slot-scope="row" class='justify-content-center'>
								<b-row class="mb-2">
									<b-col cols="7"><b>Terminal Cost</b></b-col>
									<b-col cols="5"><b>Percentage</b></b-col>
									<!--b-col></b-col-->
								</b-row>
								<b-row class="mb-2  ml-2" v-for="(terminal_cost, index1) in model.unload_locations[row.index].terminal_costs" :key="index1">
									<b-col cols="7" class="p-1">
										<b-form-input v-if="edit" size="sm" id="terminal_cost_name" v-model="model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name" type="text" />
										<span v-else>{{model.unload_locations[row.index].terminal_costs[index1].terminal_cost_name}}</span>
									</b-col>
									<b-col cols="3" class="p-1">
										<b-form-input v-if="edit" size="sm" id="terminal_cost_percentage" v-model="model.unload_locations[row.index].terminal_costs[index1].percentage" type="text" @keydown.native="myOnlyNumber($event, 'percentage')"/>
										<span v-else>{{model.unload_locations[row.index].terminal_costs[index1].percentage1}}</span>
									</b-col>
									<b-col v-if="edit" cols="2" class="p-0 pt-1"><b-btn v-b-tooltip.hover title="Delete Terminal Cost" v-on:click="removeterminalcost(row, index1)" size="sm"><i class="icon-close"></i></b-btn></b-col>
								</b-row>
						</template>
						<template slot="name" slot-scope="item">
							<span>{{model.unload_locations[0].name}}</span>  
						</template>
						<template slot="shipping_cost" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="shipping_cost" v-model="model.unload_locations[item.index].shipping_cost" type="text" />
							<span v-else>{{model.unload_locations[item.index].shipping_cost}}</span>
						</template>
						<template slot="monthly_commitment" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="monthly_commitment" v-model="model.unload_locations[item.index].monthly_commitment" type="text" @keydown.native="myOnlyNumber($event, 'monthly_commitment')"/>
							<span v-else>{{model.unload_locations[item.index].monthly_commitment1}}</span>
						</template>
						<template slot="contact_person" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="contact_person" v-model="model.unload_locations[item.index].contact_person" type="text" />
							<span v-else>{{model.unload_locations[item.index].contact_person}}</span>
						</template>
						<template slot="contact_email" slot-scope="item">
							<b-form-input v-if="edit" size="sm" id="contact_email" v-model="model.unload_locations[item.index].contact_email" type="text" />
							<span v-else>{{model.unload_locations[item.index].contact_email}}</span>
						</template>
					</b-table>
				</b-card>
				
				<b-card title="Load Locations" class="p-0 m-0 mb-3">
					<div v-if="edit">
						<b-form-group v-if="loadlocationselect.length > 0" :label-cols="1" id="L6" label="" label-for="loadLocationsID1" horizontal>
							<b-form-checkbox-group value-field="id" text-field="legal_location"  class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
							<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="LLToggleAll">
								{{ llAllSelected ? 'Un-select All' : 'Select All' }}
							</b-form-checkbox>
						</b-form-group>
						<p v-else>{{model.energy_company_id != null ? 'There are no registered Load locations for the selected Energy Company' : 'No Energy Company selected'}}</p>
					</div>
					<div v-else>
						<b-form-group v-if="model.load_locations.length > 0" :label-cols="1" id="L5" label="" label-for="loadLocationsID" horizontal>
							<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.load_locations" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
						</b-form-group>
						<p v-else>No Load Locations have been added</p>
					</div>
				</b-card>
				<b-row>
					<b-col md="6">
						<div v-if="edit" slot="footer">
							<b-button @click="update_terminal_agreement" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>&nbsp;
							<b-button @click="edit_terminal_agreement" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
						</div>
					</b-col>
				</b-row>
			</b-card>
			<b-row v-else>
				<b-col cols="12" sm="12" md="12" lg="12">
					<br>
					<p class="text-center text-danger">
						<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
					</p>
				</b-col>
			</b-row>
        </div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import t_agreement from './t_agreement'
	import moment from 'moment';
	export default {
		name: 'm_tagreement',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getAgreementData()
		},
		data() {
			return {
				originalData: null,
				edit: false,
				loadingData: true,
				tabIndex: 0,
				found: false,
				notFoundMessage: 'Not found',
				model:{
						id 										: null,
						energy_company_id 		: null,
						energy_company 				: '',
						terminal_company_id 	: null,
						terminal_company   		: '',
						terminal_id 					: null,
						terminal				   		: '',
						initial_date 					: null,
						end_date 							: null,
						rate									: null,
						fluid_type_id					: null,
						fluid_type						: '',
						other_terms						: [],
						treatfees							: [{
								treatment_fee_type_id		: null,
								treatment_fee_type_name	: '',
								treatment_fee						: null,
								condition_id						: null,
								condition_name					: null,
								percentage							: null,
																	}],
						otherfees							: [{
							terminal_rate				: null,
							rate								: null
																	}],
						unload_locations  		: [{
							id									: null,
							name								: null,
							shipping_cost				: null,
							monthly_commitment	: null,
							contact_person			: null,
							contact_email				: null,
							terminal_costs			: [],
																	}],
						load_locations_id			: [],
						load_locations				: [],
				},
				
				rate: '',
				subTitle: "",
				
				role:'',
				view:true,
				savebtn:true,
				energy_company_id :null,
				initial_date :'',
				end_date :'',
				load_locations				: [],
				// add by Carlos rondon 21/03/2019
				update_data					:	null,
				fluidtypes					: 	[],
				terminalcompanies		: 	[],
				treatment_fee_type	: 	[],
				condition						: 	[],
				locations						: 	[],
				energycompanies			: 	[],
				fluid_type  				: {'id':null,'name':'',stream_type:[]},
				other_term					: { blending_dry_fee:null, stream_type_id:null},
				loadlocationselect	: [],
				indeterminateLL			: false,
				llAllSelected				: false,
				treatfees: {
						treatment_fee_type_id	:null,
						treatment_fee					: null,
						condition_id					: null,
						percentage						: null,
				},
				otherfees: {
						terminal_rate				: null,
						rate								: null
				},
				unload_location				  :{
						id									: null,
						name								: null,
						shipping_cost				: null,
						monthly_commitment	: null,
						contact_person			: null,
						contact_email				: null,
						terminal_costs			: [{terminal_cost_name: null, percentage : null}]
				},
				terminal_cost   				: {terminal_cost_name: null, percentage : null},
				other_term							: { blending_dry_fee:null, stream_type_id:null},
				newUnloadLocation			  : false,
				u_location_id						: '',
				terminals								: []
			}
		},
		methods: {
			loadLocationsChange() {
					if (this.load_locations_id===true ) {
						return
					}
					this.model.load_locations_id = this.load_locations_id
					if (this.role =='super_admin') {
						if (this.model.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
						} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
						} else {
						this.indeterminateLL = true
						this.llAllSelected = false
						}
					}
			},
			LLToggleAll(checked) {
				if (checked===true) {
					 this.load_locations_id = this.loadlocationselect.map(item => {
																						return item.id
																					})
				} else {
						this.load_locations_id = []
				}
				this.model.load_locations_id = this.load_locations_id
			},
			myOnlyNumber(evt, variableName) {
				let dotPosition = [variableName].indexOf(".")
				let hasDot = dotPosition > -1
				let length = [variableName].length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			isNumber: function(evt, hasDot, dotPosition, length) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					let selectionStart = evt.target.selectionStart;
					let selectionEnd = evt.target.selectionEnd;
					if ((hasDot && selectionEnd > dotPosition && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
						evt.preventDefault();
					} else {
							return true
					}
				} else {
						evt.preventDefault();
				}
			},
			setupFields() {
				if (this.role =='super_admin') {
					let energy_companies = this.update_data.energy_companies
					let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						let loadlocations = energy_companies[energy_company_index].load_locations
						this.loadlocationselect = [...loadlocations]
					} else {
						this.loadlocationselect = []
					}
				}
				this.load_locations_id = []
				if (this.model.load_locations.length > 0) {
					this.load_locations_id = this.model.load_locations.map(item => {
						return item.id
					})
				} 
				 
				for(let i=0; i<this.fluidtypes.length; i++)
				{
					if(this.fluidtypes[i].name === this.model.fluid_type)
					{ 
						this.fluid_type.name = this.fluidtypes[i].other.name
						this.fluid_type.id = this.fluidtypes[i].other.id
						this.fluid_type.stream_type = this.fluidtypes[i].other.stream_type
						break;
					}
				} 
      		},
			edit_terminal_agreement() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
					
				} else {
					this.setupFields()
					this.edit = true
				}
				
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = JSON.parse(JSON.stringify(model))
				this.initial_date = moment(this.model.initial_date).format('MMM DD, YYYY')
				this.end_date = moment(this.model.end_date).format('MMM DD, YYYY')
			},
			getAgreementData() {
				t_agreement.getBy(this.id)
					.then(data => {
						if (data[0] == 'success') {
							this.originalData = data[1]
							this.update_data  = data[2]
							this.restoreOriginalData()
							this.subTitle = this.originalData.energy_company
							this.found = true
							this.loadingData = false
							this.edit = false
							this.role = data[3]
							if (this.role =='super_admin') {
								this.view=true
							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
								this.view=false
								this.energy_company_id = data[4]
								this.model.load_locations_id = []
								this.model.energy_company_id = this.energy_company_id
							}
							this.get_attributtes()
						} else {
							this.$swal(data[0], data[1], data[0])
							this.loadingData = false
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
						this.$router.push('/terminal_agreements')
					})
			},
			okToUpdate() {
				if (this.role =='super_admin') {
						if( this.model.energy_company_id == null) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
					}
					if(this.model.fluid_type_id == null) {
						this.$swal('Alert!', 'Fluid Type not selected', 'warning')
						return false
					} else if(this.model.initial_date == null || this.model.initial_date == '') {
						this.$swal('Alert!', 'Initial Date not selected', 'warning')
						return false
					} else if(this.model.end_date == null || this.model.end_date == '') {
						this.$swal('Alert!', 'End Date not selected', 'warning')
						return false
					} else if( this.model.rate == null || this.model.rate == '') {
						this.$swal('Alert!', 'Rate cannot be empty', 'warning')
						return false
					} else if( this.model.terminal_company_id == null) {
						this.$swal('Alert!', 'Terminal Company not selected', 'warning')
						return false
					} else if( this.model.terminal_id == null) {
						this.$swal('Alert!', 'Terminal not selected', 'warning')
						return false
					} else if(this.model.other_terms.length > 0) {
						if(this.model.other_terms[0].stream_type_id==null){
							this.$swal('Alert!', 'Stream Type not selected', 'warning')
							return false
						} else if(this.model.other_terms[0].blending_dry_fee==null || this.model.other_terms[0].blending_dry_fee == '') {
							this.$swal('Alert!', 'Blending Dry Fee cannot be empty', 'warning')
							return false
						}
					} else if(this.model.treatfees.length>0){
							let length = this.model.treatfees.length;
							for (var i = 0; i < length; i++) {
								if(this.model.treatfees[i].treatment_fee_type_id == null) {
									this.$swal('Alert!', 'Treatment fee type not selected', 'warning')
									return false
								} else if(this.model.treatfees[i].treatment_fee	== null || this.model.treatfees[i].treatment_fee == '') {
									this.$swal('Alert!', 'Treatment fee cannot be empty', 'warning')
									return false
								} else if(this.model.treatfees[i].condition_id	== null) {
									this.$swal('Alert!', 'Condition of treatment fee not selected', 'warning')
									return false
								} else if(this.model.treatfees[i].percentage == null || this.model.treatfees[i].percentage	=='') {
									this.$swal('Alert!', 'Percentage of treatment fee cannot be empty', 'warning')
									return false
								}
							} 
					} 
					
					if(this.model.otherfees.length>0){
							let length = this.model.otherfees.length;
							for (var i = 0; i < length; i++) {
								if(this.model.otherfees[i].terminal_rate == null || this.model.otherfees[i].terminal_rate == '') {
									this.$swal('Alert!', 'Other fee terminal rate cannot be empty', 'warning')
									return false
								} else if(this.model.otherfees[i].rate	== null || this.model.otherfees[i].rate	== '') {
									this.$swal('Alert!', 'Other fee rate cannot be empty', 'warning')
									return false
								}  
							}			
					} 
					
					if(this.model.unload_locations.length>0){
							let length = this.model.unload_locations.length;
							for (var i = 0; i < length; i++) {
								if(this.model.unload_locations[i].id == null) {
									this.$swal('Alert!', 'Unload location not selected', 'warning')
									return false
								}
								else if(this.model.unload_locations[i].shipping_cost==null || this.model.unload_locations[i].shipping_cost=='') {
									this.$swal('Alert!', 'Shipping cost	 cannot be empty', 'warning')
									return false
								} else if(this.model.unload_locations[i].monthly_commitment	== null || this.model.unload_locations[i].monthly_commitment=='') {
									this.$swal('Alert!', 'Monthly commitment cannot be empty', 'warning')
									return false
								} else if(this.model.unload_locations[i].contact_person	== null || this.model.unload_locations[i].contact_person=='') {
									this.$swal('Alert!', 'Contact person cannot be empty', 'warning')
									return false
								} else if(this.model.unload_locations[i].contact_email	== null || this.model.unload_locations[i].contact_email=='') {
									this.$swal('Alert!', 'Contact email cannot be empty', 'warning')
									return false
								}
								if(this.model.unload_locations[i].terminal_costs.length>0){
									let length1 = this.model.unload_locations[i].terminal_costs.length;
									for (var j = 0; j < length1; j++) {
										if(this.model.unload_locations[i].terminal_costs[j].terminal_cost_name==null || this.model.unload_locations[i].terminal_costs[j].terminal_cost_name=='' ) {
											this.$swal('Alert!', 'Terminal cost	 cannot be empty', 'warning')
											return false
										} else if(this.model.unload_locations[i].terminal_costs[j].percentage	== null || this.model.unload_locations[i].terminal_costs[j].percentage	== '') {
											this.$swal('Alert!', 'Percentage of terminal cost cannot be empty', 'warning')
											return false
										}
									}			
							  }
							}
					}

					if(this.model.load_locations_id.length==0){
						this.$swal('Alert!', 'Load location not selected', 'warning')
						return false
					}
					return true	
					
			},
			update_terminal_agreement() {
				if(!this.okToUpdate()) {
          			return
				}
				if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
					this.model.energy_company_id = this.energy_company_id
				}
				t_agreement.update(this.model.id, this.model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							if (data[0] == 'success') {
								this.getAgreementData()
								this.edit=false
							} 
						})
					.catch(error => {
							this.$swal('Error', 'Server not response. ' + error, 'error')
					})
				},
			delete_terminal_agreement() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Terminal Agreement: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						t_agreement.delete(this.model.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.push('/terminal_agreements')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			select_energy_companies1() {
				if (this.role =='super_admin') {
					this.model.energy_company_id = ''

					let locations = this.update_data.locations_unload
					let location_index = locations.map(o => o.id).indexOf(this.model.location_id)

					if (location_index > -1) {

						let energycompanies = locations[location_index]['energy_companies']
						this.energycompanies = energycompanies.map(item => {
							return { 'value': item.id, 'text': item.name }
						})
						// SAME as in APP - Select if there is only one item in the array
						if (this.energycompanies.length == 1) {
							this.model.energy_company_id = this.energycompanies[0].value

							let energycompanies = locations[location_index]['energy_companies']
							let energycompanies_index = energycompanies.map(o => o.id).indexOf(this.selectedTruckingC)
						}
					}
				}
			},
			select_fluid_type() {
						this.model.fluid_type_id = this.fluid_type.id
						if (this.fluid_type.name=='Oil') {
								this.model.other_terms.push(this.other_term)
						} else {
							  this.model.other_terms = []
						}
			},
			select_energy_company() {
				if (this.role =='super_admin') {
					let energy_companies = this.update_data.energy_companies
					let energy_company_index = energy_companies.map(o => o.id).indexOf(this.model.energy_company_id)
					if (energy_company_index > -1) {
						let loadlocations = energy_companies[energy_company_index].load_locations
						this.loadlocationselect = [...loadlocations]
					} else {
						this.loadlocationselect = []
					}
					this.model.load_locations_id = []
					this.load_locations_id = []
				}
			},
			removetreatmentfee(treatfee) {
				this.model.treatfees.splice(treatfee,1)
			},
			removeotherfee(otherfee) {
				this.model.otherfees.splice(otherfee,1)
			},
			removelocation(location) {
				let unload_l= {
					value: this.model.unload_locations[location].id,
					text: this.model.unload_locations[location].name
				}
				this.locations.push(unload_l)
				this.locations.sort(function (a, b) {
				if (a.text > b.text) {
					return 1;
				}
				if (a.text < b.text) {
				return -1;
				}
				// a must be equal to b
				return 0;
				})
				this.model.unload_locations.splice(location,1)
			},
			removeterminalcost(row, terminalcost) {
				this.model.unload_locations[row.index].terminal_costs.splice(terminalcost,1)
				
				if(this.model.unload_locations[row.index].terminal_costs.length == 0){
					row.toggleDetails()
				}
			},
			addunloadlocation_2() {
					let unload_location	= {
						id: null,
						name: null,
						shipping_cost: null,
						monthly_commitment: null,
						contact_person: null,
						contact_email: null,
						terminal_costs: []
					}
					this.model.unload_locations.push(unload_location)
			},
			addtreatmentfee() {
					this.model.treatfees.push(this.treatfees)
					this.treatfees= {
					treatment_fee_type_id	:null,
					treatment_fee					: null,
					condition_id					: null,
					percentage						: null,
			}
			},
			otherfee() {
					this.model.otherfees.push(this.otherfees)
					this.otherfees= {
					terminal_rate				: null,
					rate								: null
			}
			},
			addterminalcost(row) {
				let index = row.index
				let terminal_cost= {
					terminal_cost_name: null,
					percentage	: null
				}
				this.model.unload_locations[index].terminal_costs.push(terminal_cost)
				this.terminal_cost= {
					terminal_cost_name: null,
					percentage	: null
				}
				if (!row.detailsShowing)
				{
					row.toggleDetails()
				}
			},
			showunloadlocation() {
					this.newUnloadLocation=true
			},
			select_terminal() {
				if (this.role =='super_admin') {
					let terminals = this.update_data.terminals
					let terminal_index = terminals.map(o => o.id).indexOf(this.model.terminal_id)
					if (terminal_index > -1) {
						if (terminals[terminal_index].unload_location.length>0) {
							this.model.unload_locations = []
							let unload_locations  		= {
								id									: terminals[terminal_index].unload_location[0].id,
								name								: terminals[terminal_index].unload_location[0].name,
								shipping_cost				: null,
								monthly_commitment	: null,
								contact_person			: null,
								contact_email				: null,
								terminal_costs			: [],
							}
							this.model.unload_locations.push(unload_locations)
						} else {
							this.model.unload_locations = []
						}
						
					} else {
						this.model.unload_locations = []
					}
				}		
			},
			get_attributtes() {
				t_agreement.get_attr_ta()
					.then(data => {
						if (data.status == 'success') {
							if(data.insert_data) {
								this.update_data = data.insert_data
								if (this.update_data.locations_unload.length!=0) {
									this.locations  = 	this.update_data.locations_unload.map(item => {
															return { text: item.name, value: item.id }
														})
								}

								if (this.update_data.fluidtypes.length!=0) {
									this.fluidtypes  = this.update_data.fluidtypes
								}
								this.energycompanies  = this.update_data.energy_companies
								
								this.terminalcompanies  = this.update_data.terminal_companies
								this.terminals  	    = this.update_data.terminals	
								
								if (this.update_data.treatment_fee_type.length!=0) {
									this.treatment_fee_type	= 	this.update_data.treatment_fee_type.map(item => {
																	return { text: item.name, value: item.id }
																})
								}

								if (this.update_data.conditions.length!=0) {
									this.condition = this.update_data.conditions.map(item => {
														return { text: item.name, value: item.id }
													})
								}
								if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
									if (this.energycompanies.length!=0) {
										let loadlocations = this.energycompanies[0].load_locations
										this.loadlocationselect = [...loadlocations]
									} else {
										this.loadlocationselect = []
									}
								}
							}
						} else {
							this.$swal(data.status, data.message, data.status)
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
			},
		}
	}
</script>
<style scoped>
	/deep/ .col-form-label{
		font-weight: bold;
	}

	.card-body, .card-block, .card-block {
    	padding: 0.1rem;
	}
	.card-body >>> .b-table.table.b-table-stacked > tbody > tr > [data-label] {
		display: grid;
		grid-template-columns: 16% 84%;
		grid-gap: 0.25rem 1rem;
	}
	.form-control:disabled, .form-control[readonly] {
		background-color: #f7fbfd;
		opacity: 1;
		color: #000000;
	}
/deep/	.custom-checkboxes .form-check-inline {
	 width: 35vh;
	}
/deep/	.custom-checkboxes .form-check-label {
    	overflow: unset;
	}
</style>



// WEBPACK FOOTER //
// src/views/terminal_agreements/terminal_agreement.vue